module.exports = __webpack_public_path__ + "static/img/government_bg4.784f749.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/government_bg4.png
// module id = 7H4s
// module chunks = 44